import { css } from "@emotion/react";
import PopronNetworkHiTechGraphicBlazingHot from "../../../../assets/img/ewa_background.png";
import styled, { ThemedCssCreator } from "../../../../config/emotion";

export const mainContainerWrapperCss: ThemedCssCreator = (theme) => css`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-image: url(${PopronNetworkHiTechGraphicBlazingHot});
  background-repeat: no-repeat;
  background-position: right top;
  background-color: ${theme.colors.bgColor};
`;

export const MainContainer = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;

  box-sizing: border-box;
  padding: 4rem;
  padding-top: 4.3rem;

  @media only screen and (max-width: 1024px) {
    padding-top: 50px;
    background: ${({ theme }) => theme.colors.bgColor};
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
`;

export const innerContainerCss = css`
  width: 90%;
  flex: 1;
  margin: 0 auto;
  padding-bottom: 2.5rem;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    overflow-x: inherit; // action buttons should be sticky -> overflow-x must be deactivated
    // see for more information - https://stackoverflow.com/questions/44446671/my-position-sticky-element-isnt-sticky-when-using-flexbox
    .table-sticky-container {
      position: -webkit-sticky;
      position: sticky;
      top: 79px;
      background: $ternary-bg;
      z-index: 10;
      margin: 5px 0px 5px 0px;
    }
  }

  .add-record-btn,
  .filter-table-btn {
    border-radius: 7px;
  }

  object {
    &.file-preview {
      width: 100%;
      height: 100%;
    }
  }
`;

export const footerCss = css`
  position: absolute;
  color: #c0c6d0;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  height: 4.5rem;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;
